import { ScreenType } from '@tmdb-graphql-api/schema/types';
import { type DiscoverMovieFilters, type DiscoverTvFilters } from '#types.ts';
import { type MovieFormikValues, type TvFormikValues } from '../types.ts';

export const areDiscoverMovieFilters = (
  _values: DiscoverMovieFilters | DiscoverTvFilters,
  type: ScreenType,
): _values is DiscoverMovieFilters => type === ScreenType.Movie;

export const areMovieFormikValues = (
  _values: MovieFormikValues | TvFormikValues,
  type: ScreenType,
): _values is MovieFormikValues => type === ScreenType.Movie;
